const cols = [
  { title: "深扒分区", links: ["背后真相", "未解之谜", "知情人士线索墙", "实时快讯", "深扒档案"] },
  { title: "参与讨论", links: ["社区热聊", "今日吃瓜榜", "跟评求证", "贡献线索", "纠错反馈"] },
  { title: "关于黑网", links: ["关于我们", "编辑守则", "线索核实流程", "内容申诉", "联系方式"] },
];

export default function CtaFooter() {
  return (
    <>
      {/* 爆料 CTA */}
      <section id="cta" className="relative overflow-hidden bg-background-950 py-20 md:py-28">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute left-1/2 top-0 h-px w-full -translate-x-1/2 bg-gradient-to-r from-transparent via-primary-500/60 to-transparent"></div>
          <div className="absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-primary-500/10 blur-3xl"></div>
          <div className="absolute -right-20 top-0 h-72 w-72 rounded-full bg-accent-500/10 blur-3xl"></div>
        </div>

        <div className="relative mx-auto max-w-3xl px-4 text-center md:px-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 px-4 py-1.5 text-xs font-medium text-primary-300">
            <i className="ri-feedback-fill"></i> 匿名 & 可追溯
          </span>
          <h2 className="font-heading mt-6 text-balance text-3xl font-bold leading-tight text-foreground-50 md:text-5xl">
            你有内幕？<br className="md:hidden" />
            <span className="text-primary-400">让真相多一个见证者</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-balance text-sm leading-relaxed text-foreground-400 md:text-base">
            深扒世界需要你的情报。后台核验线索真伪、查重与时效后，会与你的化名一同归档，让每一次「吃瓜」都有据可查。
          </p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              type="button"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-400 sm:w-auto"
            >
              <i className="ri-add-circle-line text-lg"></i>
              提交我的线索
            </button>
            <button
              type="button"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-700 bg-background-900 px-6 py-3.5 text-sm font-medium text-foreground-200 transition-colors hover:border-background-500 hover:text-foreground-50 sm:w-auto"
            >
              查看核实流程
              <i className="ri-arrow-right-line text-accent-400"></i>
            </button>
          </div>
        </div>
      </section>

      {/* 页脚 */}
      <footer className="border-t border-background-800 bg-background-950 pb-10">
        <div className="mx-auto max-w-[1280px] px-4 pt-16 md:px-6">
          <div className="grid grid-cols-2 gap-10 md:grid-cols-4 lg:grid-cols-5">
            <div className="col-span-2 md:col-span-2 lg:col-span-2">
              <div className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-eye-line text-lg text-background-950"></i>
                </span>
                <span className="leading-none">
                  <span className="font-heading block text-lg font-bold text-foreground-50">
                    吃瓜<span className="text-primary-400">黑网</span>
                  </span>
                  <span className="mt-0.5 block text-[10px] tracking-[0.2em] text-foreground-500">内幕 · 线索 · 求证</span>
                </span>
              </div>
              <p className="mt-5 max-w-sm text-sm leading-relaxed text-foreground-400">
                专注内幕揭秘与背后真相的社区化深扒平台，汇集知情人士线索整理与未解之谜，所有内容持续更新，供每一位求真的读者交叉求证。
              </p>
              <div className="mt-6 flex gap-2">
                {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-youtube-line"].map((c) => (
                  <span
                    key={c}
                    className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-800 text-foreground-400 transition-colors hover:border-background-600 hover:text-foreground-100"
                  >
                    <i className={`${c} text-lg`}></i>
                  </span>
                ))}
              </div>
            </div>

            {cols.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-sm font-semibold text-foreground-100">{col.title}</h4>
                <ul className="mt-5 space-y-3">
                  {col.links.map((l) => (
                    <li key={l}>
                      <a href="#top" className="text-sm text-foreground-400 transition-colors hover:text-foreground-100">
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* 免责声明 */}
          <div className="mt-14 rounded-xl border border-background-800 bg-background-900/60 p-5 text-xs leading-relaxed text-foreground-500">
            <span className="mb-1.5 flex items-center gap-1.5 font-medium text-foreground-300">
              <i className="ri-shield-check-line text-accent-400"></i> 免责声明
            </span>
            本站深扒内容基于公开信息、网络留痕与知情人士线索整理，标注可信度并持续更新。未经法院终审或权威核实的信息，仅作讨论与求证参考，不代表事实认定或对任何主体的负面评价。请读者独立判断、理性讨论，勿据此作出任何个人或商业决策。
          </div>

          <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 text-xs text-foreground-500 sm:flex-row">
            <span>© {new Date().getFullYear()} 吃瓜黑网 · 保留所有权利</span>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
              <a href="#top" className="hover:text-foreground-200">使用协议</a>
              <a href="#top" className="hover:text-foreground-200">隐私政策</a>
              <a href="#top" className="hover:text-foreground-200">内容申诉</a>
              <a href="#top" className="hover:text-foreground-200">皖ICP备XXXXXXXX号</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}